import { render, staticRenderFns } from "./accountSafe.vue?vue&type=template&id=575a4067&scoped=true&"
import script from "./accountSafe.vue?vue&type=script&lang=js&"
export * from "./accountSafe.vue?vue&type=script&lang=js&"
import style0 from "./accountSafe.vue?vue&type=style&index=0&id=575a4067&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575a4067",
  null
  
)

export default component.exports